import React from 'react';
import Hero from './Hero';
import AboutSection from './AboutSection';
import JourneySection from './JourneySection';
import StrengthsSection from './StrengthsSection';
import WorksSection from './WorksSection';
import StackSection from './StackSection';
import TravelsSection from './TravelsSection';
import ContactSection from './ContactSection';

function PortfolioPage({ projects, language, mode }) {
  return (
    <div className="portfolio-page">
      <Hero language={language} mode={mode} projectCount={projects.length} />
      {mode === 'traveler' ? <TravelsSection language={language} /> : null}
      <AboutSection language={language} mode={mode} />
      <JourneySection language={language} mode={mode} />
      <StrengthsSection language={language} />
      <WorksSection projects={projects} language={language} />
      <StackSection projects={projects} language={language} />
      <ContactSection language={language} />
    </div>
  );
}

export default PortfolioPage;
